import React from 'react';

import { Grid } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { StyledTypography } from 'styles/common';

import { Separator } from './styles';

export const NoDataComponent = () => <StyledTypography color="#888">No data found</StyledTypography>;

export const TwoGridSkeleton = () => (
  <>
    {[0, 1].map((i) => (
      <>
        <Grid container>
          <Grid xs={6}>
            <Skeleton width="30%" />
          </Grid>
          <Grid xs={6}>
            <Skeleton width="40%" />
          </Grid>
        </Grid>
        {i === 0 && <Separator />}
      </>
    ))}
  </>
);
